import React from 'react';
import { Field } from 'redux-form';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import ReactCountdownClock from 'react-countdown-clock';
import TextInput from 'components/TextInput';
import { required, isEmail, minLength, maxLength } from 'helpers/field-validator';

const styles = theme => ({
  typography: {
    marginBottom: theme.spacing(2),
  },
  fieldRow: {
    marginTop: theme.spacing(),
    marginBottom: theme.spacing(),
  },
  btnRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(3),
  },
});

const maxLength30 = maxLength(30);
const maxLength100 = maxLength(100);
const minLength3 = minLength(3);
const minLength8 = minLength(8);

export const User = ({
  classes,
  firstName,
  lastName,
  error,
  onChangeFN,
  onChangeLN,
  handleSubmit,
  pristine,
  submitting,
  invalid,
  success,
  onComplete,
}) => (
  <div>
    {!success && (
      <div>
        <Typography variant="h5" className={classes.typography}>
          Hey {firstName} {lastName}!
        </Typography>
        <Typography variant="subheading" className={classes.typography}>
          Let's create your user account
        </Typography>
        <form onSubmit={handleSubmit} noValidate autoComplete="off">
          <div className={classes.fieldRow}>
            <Field
              label="First name"
              name="firstName"
              onChange={onChangeFN}
              inputProps={{ maxLength: 30 }}
              validate={[required, maxLength30]}
              component={TextInput}
              fullWidth
              required
            />
          </div>
          <div className={classes.fieldRow}>
            <Field
              label="Last name"
              name="lastName"
              onChange={onChangeLN}
              inputProps={{ maxLength: 30 }}
              validate={[required, maxLength30]}
              component={TextInput}
              fullWidth
              required
            />
          </div>
          <div className={classes.fieldRow}>
            <Field
              label="Email"
              name="email"
              inputProps={{ maxLength: 100 }}
              validate={[required, isEmail, maxLength100]}
              component={TextInput}
              disabled
              fullWidth
              required
            />
          </div>
          <div className={classes.fieldRow}>
            <Field
              label="Username"
              name="username"
              inputProps={{ maxLength: 30 }}
              validate={[required, minLength3, maxLength30]}
              component={TextInput}
              fullWidth
              required
            />
          </div>
          <div className={classes.fieldRow}>
            <Field
              label="Password"
              name="password"
              type="password"
              validate={[required, minLength8]}
              component={TextInput}
              fullWidth
              required
            />
          </div>
          <div className={classes.fieldRow}>
            <Field
              label="Confirm password"
              name="confirmPassword"
              type="password"
              validate={[required, minLength8]}
              component={TextInput}
              fullWidth
              required
            />
          </div>
          {error && (
            <Typography variant="caption" color="error">
              {error}
            </Typography>
          )}
          <div className={classes.btnRow}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={pristine || submitting || invalid}
            >
              create
            </Button>
          </div>
        </form>
      </div>
    )}
    {success && (
      <div>
        <Typography color="primary" variant="h5" className={classes.typography}>
          Success! Thank you for registering!
        </Typography>
        <Typography className={classes.typography}>
          You now should be able to login and enjoy our amazing features.
        </Typography>
        <ReactCountdownClock
          seconds={15}
          size={50}
          weight={5}
          color="#044591"
          onComplete={onComplete}
        />
        <Typography variant="caption">You will be redirected shortly.</Typography>
      </div>
    )}
  </div>
);

export default withStyles(styles)(User);
